import { TutorialProvider } from './../../providers/tutorial/tutorial';
import { Component, OnDestroy } from "@angular/core";
import { NavController, LoadingController,  AlertController} from '@ionic/angular';
import { ResultProvider, StatisticsResults } from '../../providers/result/result';
import { RequestProvider } from '../../providers/request/request';
import { ConfigProvider } from '../../providers/config/config';
import { EventProvider } from "../../providers/event/event";
import { ModalController } from "@ionic/angular";
import { ModalConfigureGeoComponent } from '../../components/modal-configure-geo/modal-configure-geo';
import { StorageProvider } from "../../providers/storage-service/storage-service";
import { LocationProvider } from "../../tracker/location-handler";
import { AutoPause } from "../../tracker/autopause/autopause";
import { TranslateService } from '@ngx-translate/core';
import { ResultListModel } from "../../providers/result/result";
import { AddAthletePage } from "../add-athlete/add-athlete";
import { Storage } from "@ionic/storage";
import { EditAthleteData } from "../edit-athlete-data/edit-athlete-data";
import { SettingsProvider } from '../../providers/settings/settings';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'anmeldungen-page',
    templateUrl: 'anmeldungen-page.html',
    styleUrls:['./anmeldungen-page.scss']
})

export class AnmeldungenPage {
    userSection:any=null;
    locater: LocationProvider;
    results: any = [];
    rangListArray = [];
    events: any = [];
    eventNames: any = [];
    activeEvent: any;
    option = {
        applause: false,
        autoPause: false,
        placement: false
    }
    activeIndex = 0;
    editPageIsOpen: boolean = true;
    pipeDateFormat = "dd.MM.yyyy";
    
    constructor(private navCtrl: NavController,
        private router:Router,
        private resultService: ResultProvider,
        private request: RequestProvider,
        private config: ConfigProvider,
        private eventService: EventProvider,
        private modalCtrl: ModalController,
        private storageService: StorageProvider,
        private settingsService: SettingsProvider,
        private storage: Storage,
        private loadingCtrl: LoadingController,
        private tutorialProvider: TutorialProvider,
        private translate: TranslateService,
        private alertCtrl: AlertController) {
        this.settingsService.getActiveDateFormat().then(date => {
            this.pipeDateFormat = date.pipeFormat;
        });

    }

    ionViewDidEnter() {
        this.getEvents();

    }

    eventNameChange($event) {
        console.log($event);

        this.storageService.checkForExistance('rangList-' + $event.id).then((status) => {
            if (status) {
                this.storageService.getSaved('rangList-' + $event.id).then(data => {
                    for (let i = 0; i < this.results.length; i++) {
                        this.results[i].athId = i + 1;
                        this.results[i].eventId = $event.id;
                    }
                    this.results = data;
                    console.log("athletes got from storage!!");
                })
            }
            else {
                this.getAthletes($event);
                console.log("athletes aren`t saved");
            };
        });

        console.log("results " + JSON.stringify(this.results));
    }

    async getAthletes($event) {
        if (!this.tutorialProvider.isLoginAllowed) return;

        let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });

        await loader.present();

        this.results.length = 0;
        let url = `${environment.sporteventApi}event/${$event.id}/registrations`;

        this.request.get(url).toPromise().then((athletes) => {
            this.results = athletes;
            for (let i = 0; i < this.results.length; i++) {
                this.results[i].athId = i + 1;
                this.results[i].eventId = $event.id;
            }
            this.storageService.saveData(this.results, 'rangList-' + $event.id).then(() => {
                console.log("athletes saved " + JSON.stringify(this.results));
            })
            this.storageService.create().then(()=>{
                this.storageService._storage.keys().then(data => {
                    console.log("keys of storage " + JSON.stringify(data));
                    this.storageService._storage.get('rangList-' + $event.id).then((data) => {
                        console.log("data from storage " + $event.id + ' ' + JSON.stringify(data));
                    })
                });
                loader.dismiss();
            })
        });
    }

    /**
     * 
     * @param result TODO: interface for athele instead of any
     */
    async click(result: any) {
        const modal = await this.modalCtrl.create({
            component: EditAthleteData,
            componentProps: { ath: result }
        });

        modal.onDidDismiss().then(async(res) => {
            const athlete = res.data;
            if (athlete) {
                this.storageService.saveData(this.results, 'rangList-' + athlete.eventId);
                await this.storageService.create();
                this.storageService._storage.get('rangList-' + athlete.eventId).then((data) => {
                console.log("data from storage after edit " + athlete.eventId + ' ' + JSON.stringify(data));
                });
            }
        });
        await modal.present();
    }

    async openAddAthletePage() {
        let modal = await this.modalCtrl.create({component:AddAthletePage, componentProps:{ eventId: this.results[0].eventId }});
        modal.present();
        modal.onDidDismiss().then(res => {
            let ath = res.data;
            this.results.push(ath);
            ath.firstName.length ? this.storageService.saveData(this.results, 'rangList-' + ath.eventId) : this.results.pop();
        })
    }

    save() {
        this.storageService.saveData(this.results, 'rangList');
    }

    getEvents() {
        this.eventService.getClientEvents().then((events) => {
            this.events = Object.assign([], events);
            console.log('events: ' + JSON.stringify(events));
            // this.eventNames = [...new Set(this.events.map((e) => e.name))];
            this.activeEvent = this.eventNames[0];
        });
    }

    getActiveIndex(i) {
        if (i === this.activeIndex) {
            // console.log("index" + i);
            return true;
        }
        else {
            return false;
        }
    }

    async onConfigureModal() {
        const modal = await this.modalCtrl.create({component:ModalConfigureGeoComponent, componentProps:{ option: this.option }});
        modal.onDidDismiss().then((options) => {
            console.log('options', options)
            this.updateSettings(options);
        });

        modal.present();
    }

    updateSettings(options) {
        console.log('updateSettings: ');
        this.option.applause = options.applause;
        this.option.autoPause = options.autoPause;
        this.option.placement = options.placement;

        this.storageService.saveData(options.applause, 'applause');
        this.storageService.saveData(options.autoPause, 'autopause');
        this.storageService.saveData(options.placement, 'placement');

        (options.placement) ? this.getLocater().setPlacement(true) : this.getLocater().removePlacement();

        AutoPause.getInstance().setEnabled(this.option.autoPause);

        if (this.option.autoPause) AutoPause.getInstance().run();
    }

    getLocater() {
        return this.locater;
    }
};

